import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/eon-service/eon-service/node_modules/@mui/material/esm/Box/Box.js");
